
import { createAction, props } from '@ngrx/store';

export const loadFormConfig2Data = createAction('[Data FormConfig2 API] Load Data');
export const loadFormConfig2DataSuccess = createAction('[Data FormConfig2 API] Load Data Success', props<any>());
export const loadFormConfig2DataFailure = createAction('[Data FormConfig2 API] Load Data Failure', props<any>());
